/**
 * `/settings/*` (§ Instellingen, PLAN-FASE2.md WP-08). Five tabs: Profiel,
 * Huisstijl, Privacy, Modules (placeholder), Integraties.
 */
export const settings = {
  title: 'Settings',
  lead: 'Your company profile, branding and privacy settings.',
  noCompany: 'No active company selected.',
  adminOnly: 'Only a platform administrator can change this — you can see the current values.',
  save: 'Save',
  nav: {
    label: 'Settings menu',
    profile: 'Profile',
    branding: 'Branding',
    privacy: 'Privacy',
    modules: 'Modules',
  },
  profile: {
    title: 'Profile',
    name: 'Organization name',
    industry: 'Industry',
    industryHint: 'Free text, e.g. "Logistics" or "Healthcare".',
    employeeCount: 'Number of employees',
    plan: 'Plan',
    planPlaceholder: 'See Subscription',
  },
  branding: {
    title: 'Branding',
    lead: 'Your logo and accent colour, as they appear in a live preview.',
    logo: 'Upload logo',
    logoHint: 'Uploaded right away; or fill in an existing URL below.',
    logoUrl: 'Logo URL',
    upload: {
      uploading: 'Uploading…',
      tooLarge: 'File is too large (max 10MB).',
      invalidType: 'File type not allowed.',
    },
    accentColor: 'Accent colour',
    preview: 'Live preview',
    colors: {
      mint: 'Mint',
      pine: 'Pine',
      ink: 'Ink',
      amber: 'Amber',
      coral: 'Coral',
      sky: 'Sky',
    },
  },
  privacy: {
    title: 'Privacy',
    lead: 'The minimum group size for aggregate statistics, and what your company shares.',
    minGroupSize: 'Minimum group size (k-anonymity)',
    minGroupSizeHint: 'Below this, a group is too small to show aggregate statistics for.',
    minGroupSizeValue: '{{count}} people',
    effective: 'Currently in force: {{count}} people',
    aggregatedData: 'Aggregated data',
    aggregatedDataHint: 'Show aggregate statistics for groups that meet the minimum size.',
    explicitConsent: 'Explicit consent required',
    explicitConsentHint: 'Require an individual consent answer rather than collective consent.',
    dataExport: 'Data export',
    dataExportHint: 'Allow exporting statistics data.',
    auditLogHint: 'Administrative actions are always recorded in an audit trail.',
  },
  modules: {
    title: 'Modules',
    lead: 'Enable or disable the modules available to your company.',
    vitality: 'Vitality',
    vitalityHint: 'Sleep, stress, heart rate and activity tracking.',
    participation: 'Participation',
    participationHint: 'Engagement funnel and participation metrics.',
    pilots: 'Pilots',
    pilotsHint: 'Run and track pilot programs.',
    challenges: 'Challenges',
    challengesHint: 'Create and manage wellness challenges.',
    communication: 'Communication',
    communicationHint: 'Send notifications and messages to employees.',
    documents: 'Documents',
    documentsHint: 'Publish and manage company documents.',
    reports: 'Reports',
    reportsHint: 'Generate and export analytics reports.',
    ai_coach: 'AI Coach',
    ai_coachHint: 'AI-powered personalized coaching.',
  },
} as const;
